import React from "react";
import styled from "styled-components";
import {
  ControlLabel,
  DropdownButton,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  InputWrapper,
  MenuItem
} from "components/bootstrap";
const OPTIONS = [
  { value: "STRING", label: "string" },
  { value: "NUMBER", label: "number" },
  { value: "OBJECT", label: "object" },
  { value: "ARRAY", label: "array" },
  { value: "BOOLEAN", label: "boolean" },
  { value: "NULL", label: "null" }
];
const StyledFormGroup = styled(FormGroup)`
  padding: 0 15px;
`;
class JSONValueInput extends React.Component {
  constructor(props) {
    super(props);
    this._computeInitialState = () => ({
      value: this.props.value,
      valueType: this.props.valueType
    });
    this._propagateState = () => {
      this.props.update(this.state.value, this.state.valueType);
    };
    this._onUpdate = (e) => {
      const { value } = e.target;
      this.setState({ value }, this._propagateState);
    };
    this._onValueTypeSelect = (valueType) => {
      this.setState({ valueType }, this._propagateState);
    };
    this.state = this._computeInitialState();
  }
  UNSAFE_componentWillReceiveProps() {
    this.setState(this._computeInitialState());
  }
  render() {
    const options = OPTIONS.filter((o) => this.props.allowedTypes.indexOf(o.value) > -1).map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onSelect: () => this._onValueTypeSelect(o.value) }, o.label));
    return /* @__PURE__ */ React.createElement(StyledFormGroup, { validationState: this.props.validationState }, this.props.label && /* @__PURE__ */ React.createElement(ControlLabel, { className: this.props.labelClassName }, this.props.label), /* @__PURE__ */ React.createElement(InputWrapper, { className: this.props.wrapperClassName }, /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(
      FormControl,
      {
        type: "text",
        onChange: this._onUpdate,
        onBlur: this.props.onBlur,
        value: this.state.value,
        required: this.props.required
      }
    ), /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(
      DropdownButton,
      {
        id: "input-dropdown-addon",
        bsStyle: this.props.validationState === "error" ? "danger" : "default",
        title: OPTIONS.filter((o) => o.value === this.props.valueType)[0].label
      },
      options
    ))), this.props.help && /* @__PURE__ */ React.createElement(HelpBlock, null, this.props.help)));
  }
}
JSONValueInput.defaultProps = {
  value: "",
  valueType: "STRING",
  allowedTypes: OPTIONS.map((option) => option.value),
  label: "",
  help: "",
  required: false,
  validationState: null,
  labelClassName: void 0,
  wrapperClassName: void 0,
  onBlur: void 0
};
export default JSONValueInput;
